export enum PaymentOptionEnum {
  Aircash = 'aircash',
  CreditCard = 'creditCard',
  KeksPay = 'keksPay',
}